import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Rating from 'react-rating';
import intl from "react-intl-universal";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarO } from '@fortawesome/free-regular-svg-icons';

import './StarRating.css';

@observer
class StarRating extends Component {
    updateRating = (value) => {
        this.props.appStore.setPendingElementStarRating(value);
    };
    getStarRatingTitle = () => {
        return intl.get("EditModal.starRatingTitle");
    };
    render() {
        return (
            <div className="StarRating">
                <p>{this.getStarRatingTitle()}</p>
                <Rating
                    initialRating={(this.props.appStore.pendingState.element.starRating ? this.props.appStore.pendingState.element.starRating : 0)}
                    emptySymbol={<FontAwesomeIcon icon={ faStarO } size="lg"  />}
                    fullSymbol={<FontAwesomeIcon icon={ faStar } size="lg"  />}
                    onChange={this.updateRating}
                />
            </div>
        );
    }
}

export default StarRating;


// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/PopupContainer/components/StarRating/index.js